import form from './src/form.vue'

export default form
